import { createContext, ReactNode, useCallback, useState } from 'react'

import { CustomToast, StandardToast, Toast } from './types'

interface ToastContextType {
  toasts: Toast[]
  showToast: {
    (toast: Omit<StandardToast, 'id'>): string
    (toast: Omit<CustomToast, 'id'>): string
  }
  removeToast: (id: string) => void
  clearAllToasts: () => void
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined)

interface ToastProviderProps {
  children: ReactNode
}

export function ToastProvider({ children }: ToastProviderProps) {
  const [toasts, setToasts] = useState<Toast[]>([])

  function showToastImpl(toast: Omit<StandardToast, 'id'> | Omit<CustomToast, 'id'>): string {
    const id = `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    const newToast = { ...toast, id } as Toast

    setToasts(prev => [...prev, newToast])

    return id
  }

  const showToast = useCallback(showToastImpl, [])

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id))
  }, [])

  const clearAllToasts = useCallback(() => {
    setToasts([])
  }, [])

  return (
    <ToastContext.Provider
      value={{
        toasts,
        showToast,
        removeToast,
        clearAllToasts,
      }}
    >
      {children}
    </ToastContext.Provider>
  )
}
